import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { ICheckpointGroup, ICheckpointV2 } from '@fi-shared/checklist/checklist-v2';
import { isDefined } from '@fi-shared/utils/is-defined';

@Component({
    selector: 'fi-checkpoint-group-scoring',
    templateUrl: './checkpoint-group-scoring.component.html',
    styleUrls: ['./checkpoint-group-scoring.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checkpoint-group-scoring' },
    standalone: false,
})
export class FiCheckpointGroupScoringComponent {
    section = input.required<ICheckpointGroup>();

    protected sectionScoringTotal = computed(() => {
        return this.section().Checkpoints.reduce((partialSum: number, checkpoint: ICheckpointV2) => {
            return partialSum + this.getCheckpointScoring(checkpoint);
        }, 0);
    });

    private getCheckpointScoring(checkpoint: ICheckpointV2): number {
        if (!isDefined(checkpoint.ScoringData)) {
            return 0;
        }

        return checkpoint.ScoringData.OkPts + checkpoint.ScoringData.NotOkPts + checkpoint.ScoringData.NotFilledOutPts;
    }
}
